import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';

/** Carrusel horizontal con flechas (glass azul) cuando el contenido desborda. */
export function RestaurantsCarousel({ children, step = 240, deps }) {
   const trackRef = useRef(null);
   const [canPrev, setCanPrev] = useState(false);
   const [canNext, setCanNext] = useState(false);

   const update = useCallback(() => {
      const el = trackRef.current;
      if (!el) return;
      const overflow = el.scrollWidth - el.clientWidth > 4;
      setCanPrev(overflow && el.scrollLeft > 4);
      setCanNext(overflow && el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
   }, []);

   useLayoutEffect(() => { update(); }, [children, deps, update]);
   useEffect(() => {
      const el = trackRef.current;
      if (!el) return;
      update();
      const ro = new ResizeObserver(update);
      ro.observe(el);
      window.addEventListener('resize', update);
      return () => { ro.disconnect(); window.removeEventListener('resize', update); };
   }, [update]);

   const scroll = (dir) => trackRef.current?.scrollBy({ left: dir * step, behavior: 'smooth' });

   return (
      <div className="sp-rest-carousel">
         <button type="button" className={`sp-rest-carousel__arrow left ${canPrev ? 'is-visible' : ''}`} onClick={() => scroll(-1)} aria-label="Anterior" tabIndex={-1}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="15 18 9 12 15 6" /></svg>
         </button>
         <div className="sp-rest-carousel__track" ref={trackRef} onScroll={update}>
            {children}
         </div>
         <button type="button" className={`sp-rest-carousel__arrow right ${canNext ? 'is-visible' : ''}`} onClick={() => scroll(1)} aria-label="Siguiente" tabIndex={-1}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="9 18 15 12 9 6" /></svg>
         </button>
      </div>
   );
}
export default RestaurantsCarousel;